export const colors = {
  brand: "#CC0000",
  backGround: "#f7f3e8",
}
export const fontSizes = [
  "0.75rem", // 0
  "1rem", // 1
  "1.25rem", // 2
  "1.5rem", // 3
  "1.75rem", // 4
  "2rem", // 5
  "2.25rem", // 6
  "2.5rem", // 7
  "3rem", // 8
  "4rem", // 9
  "5rem", // 10
  "6rem", // 11
  "7rem", // 12
]
export const spaces = [
  4, // 0
  8, // 1
  16, // 2
  24, // 3
  32, // 4
  48, // 5
  64, // 6
  96, // 7
  128, //8
  192, //9
  256, //10
  360, //11
]

export const templateStyles = {
  grid: {
    padding: "100px 20px 30px 20px",
    "@media (max-width:900px)": {
      paddingTop: 60,
    },
  },
  title: {
    fontSize: 60,
    "@media (max-width:900px)": {
      fontSize: 40,
    },
  },
}

export const mediumStyles = {
  pc: {
    display: "block",
    "@media (max-width:670px)": {
      display: "none",
    },
  },
  mobile: {
    display: "none",
    "@media (max-width:670px)": {
      display: "block",
    },
  },
}

export const largeStyles = {
  pc: {
    display: "block",
    "@media (max-width:900px)": {
      display: "none",
    },
  },
  mobile: {
    display: "none",
    "@media (max-width:900px)": {
      display: "block",
    },
  },
}

export const sizes = {
  small: 544,
  medium: 670,
  large: 900,
  exLarge: 1200,
}

export const buttonSizes = {
  pc: {
    exSmall: "96px",
    small: "128px",
    medium: "196px",
    large: "256px",
  },
  mobile: {
    small: "30vw",
    medium: "42vw",
    large: "84vw",
  },
}

export const transitions = [250, 500, 1000]
